import * as React from "react";
import { iife } from "@repo/shared/utils/misc.ts";
import { RootPage } from "../root/RootPage.tsx";
import { useRoute } from "./router.ts";
import { MainPageLayout } from "../layout/MainPageLayout.tsx";
import { StashPage } from "../stash/StashPage.tsx";
import { ArchivePage } from "../archive/ArchivePage.tsx";
import { SettingsPage } from "../settings/SettingsPage.tsx";
import { TrashPage } from "../trash/TrashPage.tsx";
import { ExtensionPage } from "../extension/ExtensionPage.tsx";
import { ReaderPage } from "../reader/ReaderPage.tsx";

type PageName = "stash" | "archive" | "settings" | "trash";

interface Props {}

export const Routes: React.FC<Props> = ({}) => {
  const route = useRoute();
  // The reader opens over the page you were on, which stays where it was underneath, so closing
  // it puts you back in the same place in the list. Straight to a reader link, it's the Stash.
  const [page, setPage] = React.useState<PageName>("stash");
  const routePage = isPage(route.name) ? route.name : null;
  if (routePage && routePage != page) setPage(routePage);
  // Whether a list has been showing in this tab, so the reader's back can be the browser's back
  const [hasShownPage, setHasShownPage] = React.useState(false);
  if (routePage && !hasShownPage) setHasShownPage(true);

  if (route.name == "signIn") return <RootPage />;
  if (route.name == "extension") return <ExtensionPage extensionId={route.params.id} />;

  const shown = routePage ?? page;
  const readerItemId = route.name == "item" ? route.params.itemId : null;

  return (
    <>
      <MainPageLayout pageKey={shown} covered={readerItemId != null}>
        {iife(() => {
          if (shown == "stash") return <StashPage />;
          if (shown == "archive") return <ArchivePage />;
          if (shown == "settings") return <SettingsPage />;
          if (shown == "trash") return <TrashPage />;
          return null;
        })}
      </MainPageLayout>
      {readerItemId && (
        <ReaderPage itemId={readerItemId} backTo={shown} cameFromList={hasShownPage} />
      )}
    </>
  );
};

const isPage = (name: string | false): name is PageName =>
  name == "stash" || name == "archive" || name == "settings" || name == "trash";
